import { ActionIcon, Avatar, Box, FileButton, Group, Text, Title } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { I_IconSetting, useWidgetFormContext } from '@/components/WidgetSetting/form-context';

import classes from './chatbotAvatar.module.css';
import {
  SvgAddPicture,
  SvgChatbotAvatar_1,
  SvgChatbotAvatar_2,
  SvgChatbotAvatar_3,
  SvgChatbotAvatar_4,
  SvgChatbotAvatar_5,
  SvgChatbotAvatar_6,
} from './icon';

export const CHATBOT_AVATAR_ARRAY = [
  SvgChatbotAvatar_1,
  SvgChatbotAvatar_2,
  SvgChatbotAvatar_3,
  SvgChatbotAvatar_4,
  SvgChatbotAvatar_5,
  SvgChatbotAvatar_6,
];

export default () => {
  const { t } = useTranslation();
  const { hovered, ref } = useHover();
  const { form } = useWidgetFormContext();

  const [customFileSrc, setCustomFileSrc] = useState<string>('');
  const resetRef = useRef<() => void>(null);

  const changeFormChatBotIcon = (param: I_IconSetting) => {
    form.setFieldValue('chatbotAvatar', { ...param });
  };

  const systemFile = (index: number) => {
    setCustomFileSrc('');
    resetRef.current?.();

    changeFormChatBotIcon({
      type: 'system',
      index: index,
      url: '',
    });
  };

  const customFile = (file: File | null) => {
    if (!file) return;
    const reads = new FileReader();
    reads.readAsDataURL(file);
    reads.onload = function () {
      const src = this.result as string;
      setCustomFileSrc(src);

      changeFormChatBotIcon({
        type: 'custom',
        url: src,
        file: file,
      });
    };
  };

  const getCustomPreview = () => {
    if (customFileSrc) {
      return <Avatar radius="xl" src={customFileSrc} />;
    }

    return <SvgAddPicture />;
  };

  useEffect(() => {
    setCustomFileSrc(form.values.chatbotAvatar.url ?? '');
  }, [form.values.chatbotAvatar]);

  return (
    <section>
      <Title order={4}>{t('widget.setting.chatbot_avatar.title')}</Title>
      <Text size="sm" c="gray.6" mt={10}>
        {t('widget.setting.chatbot_avatar.desc')}
      </Text>
      <Box className={classes.chatbotWrap}>
        <Group justify="space-between">
          <Group>
            {CHATBOT_AVATAR_ARRAY.map((ChatbotAvatarItem, index) => (
              <ActionIcon
                key={index}
                variant={index === form.values.chatbotAvatar.index ? 'filled' : 'light'}
                size="xl"
                radius="xl"
                onClick={() => {
                  systemFile(index);
                }}
              >
                <ChatbotAvatarItem />
              </ActionIcon>
            ))}
          </Group>

          <Group>
            <section className={classes.boxVerticalLine} />
            <Box ref={ref}>
              <FileButton resetRef={resetRef} onChange={customFile} accept="image/png,image/jpeg">
                {(props) => (
                  <ActionIcon className={classes.hoverBtn} variant="outline" size="xl" radius="xl" {...props}>
                    {hovered ? <IconPlus /> : getCustomPreview()}
                  </ActionIcon>
                )}
              </FileButton>
            </Box>
          </Group>
        </Group>
      </Box>
    </section>
  );
};
